import { FeatureFlagKey } from "@repo/app-types/featureFlags/keys";
import type { FC, ReactNode } from "react";
import { Navigate } from "react-router";
import { appPaths } from "../../app/appPaths.js";
import { useIsFeatureFlagEnabled } from "../../helpers/featureFlags/hooks.js";

interface CustomerProfileGuardProps {
  children: ReactNode;
}

export const CustomerProfileGuard: FC<CustomerProfileGuardProps> = (props) => {
  const { children } = props;
  const isEnabled = useIsFeatureFlagEnabled(FeatureFlagKey.CustomerProfile);

  if (!isEnabled) {
    return <Navigate to={appPaths.playbooks.build()} replace />;
  }

  return <>{children}</>;
};
